import { tradeRewardsEndOfYearMessagingRule } from './tradeRewardsEndOfYearMessagingRule';
import { tradeRewardsEndOfYearMessagingAction } from './tradeRewardsEndOfYearMessagingAction';

export const tradeRewardsEndOfYearMessagingConfig = {
    name: 'tradeRewardsEndOfYearMessaging',
    priority: 454,
    rule: tradeRewardsEndOfYearMessagingRule,
    action: tradeRewardsEndOfYearMessagingAction,
};
